import type { CSSProperties } from "react";

export function conclusionIcon(c: string): string {
  switch (c) {
    case "success":
      return "✓";
    case "failure":
    case "timed_out":
      return "✗";
    case "cancelled":
      return "⊘";
    case "in_progress":
    case "queued":
      return "●";
    case "skipped":
      return "·";
    default:
      return "?";
  }
}

export function conclusionColor(c: string): string {
  switch (c) {
    case "success":
      return "var(--ok)";
    case "failure":
    case "timed_out":
      return "var(--err)";
    case "in_progress":
    case "queued":
      return "var(--running)";
    case "cancelled":
    case "skipped":
    default:
      return "var(--muted)";
  }
}

export function composeStatusIcon(s: string): string {
  switch (s) {
    case "done":
      return "✓";
    case "running":
      return "●";
    case "error":
      return "✗";
    default:
      return "·";
  }
}

export function composeStatusColor(s: string): string {
  switch (s) {
    case "done":
      return "var(--ok)";
    case "running":
      return "var(--running)";
    case "error":
      return "var(--err)";
    default:
      return "var(--muted)";
  }
}

/**
 * Pill-styled status badge: filled circle with a glyph centered inside.
 * Used inside Stat tiles on the detail page where the surrounding text
 * already explains "CI" / "deploy".
 */
export function statusPillStyle(color: string): CSSProperties {
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    borderRadius: 9,
    background: color,
    color: "#0e1116",
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 1,
    textDecoration: "none",
  };
}

/**
 * Labeled pill — small rectangular badge with a category word ("CI",
 * "DEPLOY") on a state-coloured background. Used in the /repos card
 * header where a bare check-mark would be ambiguous (deploy success?
 * CI success?). The word makes the category explicit; the colour still
 * encodes the state.
 */
export function labeledPillStyle(color: string): CSSProperties {
  return {
    display: "inline-flex",
    alignItems: "center",
    background: color,
    color: "#0e1116",
    fontSize: 10,
    fontWeight: 700,
    padding: "2px 6px",
    borderRadius: 3,
    lineHeight: 1.2,
    letterSpacing: 0.5,
    textDecoration: "none",
  };
}
